export type AccountType = 'guest' | 'developer' | 'company' | 'admin' | 'generic'
export type ThemeOption = 'light' | 'dark' | 'system'

export interface Skill {
  id: number
  name: string
  slug?: string
  years_of_experience?: number
}

export interface Account {
  type: string
  type_id: number
  current: boolean
  home: string
  full_name?: string
  image?: string
}

export interface ProSubscription {
  id?: string | number
  name?: string
}

export interface ProInfo {
  subscription?: ProSubscription
  team_seat_only?: boolean
}

export interface UserShape {
  id?: number
  developer_id?: number
  first_name?: string
  last_name?: string
  full_name?: string
  email?: string
  image_url?: string
  account_type: AccountType
  permissions?: string[]
  accounts?: Account[]
  skills?: Skill[]
  pro?: ProInfo
  developer_dashboard_last_visited_at?: string | null
  company_dashboard_last_visited_at?: string | null
  company_users_last_visited_at?: string | null
  [key: string]: unknown
}

export const GUEST_USER: UserShape = {
  account_type: 'guest',
  permissions: [],
  accounts: [],
}

export interface MenuData {
  videoSkills: Array<{ slug: string; name: string; popular?: boolean }>
  magazineArticles: Array<{ id: string | number; slug: string; title: string; info: string; image_url: string }>
  magazineCategories: Array<{ id: string | number; name: string; newest?: boolean }>
}

export interface WadMenuProps {
  baseUrl: string
  apiBaseUrl: string
  cdnBaseUrl: string
  language?: string
  user?: UserShape
  theme?: ThemeOption
  hideThemeSwitcher?: boolean
  labsBaseUrl?: string
}
